import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { useLang } from "@/i18n";
import { api } from "@/api";

export const Footer = () => {
    const { t } = useLang();
    const [settings, setSettings] = useState(null);

    useEffect(() => {
        api.get("/public/settings").then((r) => setSettings(r.data)).catch(() => {});
    }, []);

    const show = (v) => v && !v.includes("DA CONFIGURARE") && !v.includes("DA-CONFIGURARE");

    return (
        <footer data-testid="site-footer" className="border-t border-amber-500/15 bg-[#080909]">
            <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-4">
                <div className="md:col-span-2">
                    <Logo />
                    <p className="mt-6 text-sm text-stone-400 max-w-sm leading-relaxed">{t.footer.tagline}</p>
                </div>
                <div>
                    <h4 className="text-xs uppercase tracking-[0.25em] text-amber-400/90 font-medium">{t.footer.navigate}</h4>
                    <ul className="mt-5 space-y-3 text-sm text-stone-300">
                        <li><Link data-testid="footer-link-experiences" className="hover:text-amber-300 transition-colors" to="/esperienze">{t.nav.experiences}</Link></li>
                        <li><Link data-testid="footer-link-stays" className="hover:text-amber-300 transition-colors" to="/alloggi">{t.nav.stays}</Link></li>
                        <li><Link data-testid="footer-link-transfers" className="hover:text-amber-300 transition-colors" to="/transfer">{t.nav.transfers}</Link></li>
                        <li><Link data-testid="footer-link-itineraries" className="hover:text-amber-300 transition-colors" to="/itinerari">{t.nav.itineraries}</Link></li>
                        <li><Link data-testid="footer-link-tailor" className="hover:text-amber-300 transition-colors" to="/su-misura">{t.nav.tailor}</Link></li>
                        <li><Link data-testid="footer-link-contacts" className="hover:text-amber-300 transition-colors" to="/contatti">{t.nav.contacts}</Link></li>
                        <li><Link data-testid="footer-link-status" className="hover:text-amber-300 transition-colors" to="/stato-prenotazione">{t.nav.statusPage}</Link></li>
                    </ul>
                </div>
                <div>
                    <h4 className="text-xs uppercase tracking-[0.25em] text-amber-400/90 font-medium">{t.footer.contactsTitle}</h4>
                    <ul className="mt-5 space-y-3 text-sm text-stone-300" data-testid="footer-contacts">
                        {show(settings?.email) && <li>{settings.email}</li>}
                        {show(settings?.phone) && <li>{settings.phone}</li>}
                        {show(settings?.address) && <li>{settings.address}</li>}
                        {show(settings?.vat_number) && <li className="text-stone-500">{settings.vat_number}</li>}
                        {!show(settings?.email) && !show(settings?.phone) && (
                            <li><Link className="hover:text-amber-300 transition-colors" to="/contatti">{t.contact.title}</Link></li>
                        )}
                    </ul>
                    <div className="mt-6 flex flex-col gap-2 text-xs text-stone-500">
                        <span data-testid="footer-privacy">{t.footer.privacy}</span>
                        <span data-testid="footer-cookie">{t.footer.cookie}</span>
                        <span data-testid="footer-terms">{t.footer.terms}</span>
                        <Link to="/admin" data-testid="footer-admin-link" className="hover:text-amber-300 transition-colors mt-2">{t.footer.adminArea}</Link>
                    </div>
                </div>
            </div>
            <div className="border-t border-amber-500/10">
                <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-stone-500">
                    <span>© {new Date().getFullYear()} TOURVOYAGERS — {t.footer.rights}</span>
                    <span className="font-sub tracking-[0.3em] text-amber-500/60">TRAVEL DIFFERENTLY</span>
                </div>
            </div>
        </footer>
    );
};
